import React, { useEffect, useState } from 'react';
import { getRequisitionList } from '../../../services/OtherService';
import Pagination from '../../constant/Pagination';
import { toast } from 'react-toastify';
import TableLoaderEffect from '../../constant/TableLoader';
import DebounceSearchInput from '../../constant/DebounceSearchInput';
import CreateRequisitionModal from './CreateRequisitionModal';
import { Link } from 'react-router-dom';
import Select from 'react-select';
const statusOtpion = [
    { value: 'PENDING', label: 'PENDING' },
    { value: 'FULFILLED', label: 'FULFILLED' },
    { value: 'PARTIALLY_FULFILLED', label: 'PARTIALLY FULFILLED' },
    { value: 'REJECTED', label: 'REJECTED' },
    { value: 'CANCELLED', label: 'CANCELLED' },
    { value: 'PARTIALLY_CANCELLED', label: 'PARTIALLY CANCELLED' },
]

const RequisitionPage = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const [status, setStatus] = useState(null);
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const recordsPage = 10;

    useEffect(() => {
        fetchList(currentPage, searchQuery, status?.value || '');
    }, [currentPage, searchQuery, status]);

    const fetchList = (page, query = '', status='') => {
        setIsLoading(true);
        getRequisitionList({ page, page_size: recordsPage, query, status }).then((resp) => {
            setData(resp.data.data);
            setTotal(resp.data.total);
            setIsLoading(false);
        }).catch((err) => {
            toast.error(err?.response?.data?.message || 'Error fetching requisitions');
            setIsLoading(false);
        });
    };

    const handlePagination = (page) => {
        const newPage = page.selected + 1;
        setCurrentPage(newPage);
    };

    const handleSearchChange = (value) => {
        setSearchQuery(value);
        setCurrentPage(1)
    };

    const handleStausChange = (data) => {
        setStatus(data || null);
        setCurrentPage(1);
    }

     const handleAfterSubmit = (data) => {
        if (data) {
            setData(prevData => [data, ...prevData]);
            setTotal(prevTotal => prevTotal + 1);
        }
    }

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-body p-0">
                            <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center p-3">
                                <h4 className="mb-0">Requisitions</h4>
                                <div className='d-flex align-items-center flex-wrap gap-3'>
                                    <Select
                                        value={status}
                                        onChange={(data) => handleStausChange(data)}
                                        placeholder={"Select Status"}
                                        isClearable={true}
                                        options={statusOtpion}
                                        id={'status'}
                                        className='react-select'
                                        classNamePrefix='select'
                                    />
                                    <div className='form-group'>
                                        <DebounceSearchInput handleSearchChange={handleSearchChange} />
                                    </div>
                                    <CreateRequisitionModal onAfterSubmit={handleAfterSubmit} />
                                </div>
                            </div>

                            <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                    <thead>
                                        <tr>
                                            <th>Requisition No</th>
                                            <th>Requested By</th>
                                            <th>Fulfillment Date</th>
                                            <th>Material Count</th>
                                            <th>Status</th>
                                            <th>Requested At</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isLoading ? <TableLoaderEffect colLength={4} /> : data.map((req, index) => (
                                            <tr key={index}>
                                                <td><Link className='fw-semibold text-primary' to={`/requisition/${req.id}`}>{req.reference_no}</Link></td>
                                                <td>{req.requested_by?.name || 'N/A'}</td>
                                                <td>{req.fulfillment_date}</td>
                                                <td>
                                                    <span className="px-2 py-0 fw-normal text-bg-light border border-light rounded-1">{req.total_material}</span>
                                                </td>
                                                <td><RequisitionStatusBadge status={req.status} /></td>
                                                <td>{req.created_at}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                {!isLoading && <Pagination
                                    currentPage={currentPage}
                                    recordsPage={recordsPage}
                                    dataLength={total}
                                    handlePagination={handlePagination}
                                />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export const RequisitionStatusBadge = ({ status }) => {
    const statusClass = {
        'PENDING': 'badge badge-sm light badge-warning',
        'FULFILLED': 'badge badge-sm badge-success',
        'REJECTED': 'badge badge-sm badge-danger',
        'PARTIALLY_FULFILLED': 'badge badge-sm badge-success light',
        'CANCELLED': 'badge badge-sm badge-secondary',
        'PARTIALLY_CANCELLED': 'badge badge-sm badge-info',
    };
    return <span className={statusClass[status]}>{status.replace('_', " ")}</span>;
};

export default RequisitionPage;
